import { ChallengeType } from "@/types/challenge";

export const shareDataFormatter = (challenge: ChallengeType) => {
  return {
    title: `I'm supporting the ${challenge.name} cause that fights hunger`,
    text: "",
    url: `${window.location.origin}/challenge/${challenge.id}`,
  };
};
